import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const opportunitiesTrendSlice = createApi({
  reducerPath: "opportunitiesTrend",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  tagTypes: [
    "opportunitiesTrend",
  ],
  endpoints: (build) => ({
    getOpportunitiesTrend: build.query({
      query: ({ orgId, headers, payload }) => ({
        url: `/bank/${orgId}/dashboard/${payload.requid}/opportunities/trend`,
        method: "POST",
        headers: headers,
        body: payload,
      }),
      providesTags: (_) => ["opportunitiesTrend"],
    }),
  }),
});

export const {
  useGetOpportunitiesTrendQuery,
} = opportunitiesTrendSlice;

export const useQueryStateOpportunitiesTrend = (queryHook, args) => {
  const result = queryHook(args);
  return {
    data: result?.data?.data[0],
    isLoading: result?.isLoading,
    isFetching: result?.isFetching,
    isError: result?.isError,
    error: result?.error,
  };
};
